import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PagesSpotlightMaybeInternalProps } from './src/ui/constants.tsx';

export const entrypoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		PagesSpotlightMaybeInternalProps,
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "jira-pages-spotlight-space-connected-entry-point" */ './src/ui/PagesSpotlightMaybe.tsx'
			),
	),

	getPreloadProps() {
		return {};
	},
});
